import { createAction, props } from '@ngrx/store';
import { Dashboard, DashboardComponent, DashboardImageToUpload } from '../models/dashboard.model';
import { SimulatedEquipment } from '../../topology/models/simulatedEquipment.model';
import { SimulationType } from '@core/models/simulation-metadata.model';
import { TimestreamMetric } from '@app/home/models/metric.model';

export const resetState = createAction('[Dashboard] Reset state');

export const init = createAction('[Dashboard] Init');
export const listLoad = createAction(
  '[Dashboard] Load dashboards list',
  props<{
    dashboards: Array<Dashboard>;
    orders: Array<string>;
    simulationType: SimulationType;
    date: string;
    minDate: string;
    maxDate: string;
    requested?: string;
  }>()
);
export const listLoadError = createAction('[Dashboard] Load dashboard error');
export const requestDashboard = createAction(
  '[Dashboard] Request dashboard with his id on next init',
  props<{ dashboardId: string }>()
);

export const initEdition = createAction('[Dashboard] Secondary init only requested for editions');
export const editionLoad = createAction(
  '[Dashboard] Load simulated equipments',
  props<{
    simulated: Array<SimulatedEquipment>;
  }>()
);
export const editionLoadError = createAction('[Dashboard] Load simulated error');

// page state
export const toggleList = createAction('[Dashboard] Toggle list');
export const toggleEdition = createAction('[Dashboard] Toggle edition');
export const toggleToolbar = createAction('[Dashboard] Toggle toolbar');

// list actions
export const createDashboard = createAction('[Dashboard] Create dashboard');
export const openDashboard = createAction('[Dashboard] Open dashboard', props<{ index: number }>());
export const loadDashboard = createAction('[Dashboard] Load Dashboard details', props<{ dashboard: Dashboard }>());
export const openDashboardWithId = createAction(
  '[Dashboard] Open dashboard with his id',
  props<{ dashboardId: string }>()
);
export const openDashboardWithIdSuccess = createAction(
  '[Dashboard] Open dashboard with his id success',
  props<{ dashboard: Dashboard; index: number }>()
);
export const openDashboardWithIdError = createAction('[Dashboard] Open dashboard with his id failure');

// edition actions
export const updateDashboard = createAction(
  '[Dashboard] Update dashboard to local session',
  props<{ dashboard: Dashboard }>()
);
export const updateComponent = createAction(
  '[Dashboard] Update component to current dashboard',
  props<{ component: DashboardComponent }>()
);
export const previewComponent = createAction(
  '[Dashboard] Load preview for a component after edition',
  props<{ component: DashboardComponent }>()
);
export const removeComponent = createAction(
  '[Dashboard] Remove component to the current dashboard',
  props<{ componentId: number }>()
);

export const publishDashboard = createAction(
  '[Dashboard] Publish dashboard to a new state',
  props<{ toPublic: boolean }>()
);

// export const requestRefreshDashboard = createAction(
//   '[Dashboard] Request refresh dashboard',
//   props<{ dashboardId: string }>()
// );

export const refreshDashboard = createAction('[Dashboard] Refresh dashboard', props<{ dashboardId: string }>());
export const refreshDashboardTrigger = createAction('[Dashboard] Trigger refresh of current dashboard');

export const refreshDashboardList = createAction('[Dashboard] Refresh dashboard list');
export const refreshDashboardListSuccess = createAction(
  '[Dashboard] Refresh dashboard list successfully',
  props<{ dashboards: Dashboard[]; requested: string }>()
);

export const removeDashboard = createAction('[Dashboard] Remove dashboard', props<{ dashboardId: string }>());
export const removeDashboardSuccess = createAction(
  '[Dashboard] Remove dashboard success',
  props<{ dashboardId: string }>()
);
export const removeDashboardError = createAction('[Dashboard] Remove dashboard failure');

export const resetDashboard = createAction('[Dashboard] Reset dashboard to its server state');

export const saveDashboard = createAction('[Dashboard] Save dashboard on the server');
export const saveDashboardSuccess = createAction(
  '[Dashboard] Dashboard saved successfully',
  props<{ dashboard: Dashboard }>()
);
export const saveDashboardError = createAction('[Dashboard] Dashboard saved failure');

export const updateDashboardDate = createAction('[Dashboard] Update Dashboard date', props<{ date: string }>());

export const setTimeNavVisibility = createAction(
  '[Dashboard] Set Dashboard Time navagation visibility',
  props<{ data: boolean }>()
);
export const reverseTimeNavVisibility = createAction('[Dashboard] Reverse Dashboard Time navagation visibility');

export const addInImagesToUpload = createAction(
  '[Dashboard] Add image to the uploading list',
  props<{ imagesToUpload: DashboardImageToUpload }>()
);
export const loadDashboardImages = createAction(
  '[Dashboard] Dashboard load successfully',
  props<{ dashboard: Dashboard }>()
);

export const updateDashboardOrder = createAction(
  '[Dashboard] Save dashboard order for this user',
  props<{ id: string; index: number }>()
);
export const updateDashboardOrderSuccess = createAction(
  '[Dashboard] Dashboard order saved successfully',
  props<{ orders: string[] }>()
);
export const updateDashboardOrderError = createAction('[Dashboard] Dashboard order failed to save');

export const saveSimulatedGroups = createAction(
  '[Dashboard] Save Topologie groups',
  props<{ simulatedGroups: SimulatedEquipment[] }>()
);

export const startAnalysis = createAction(
  '[Dashboard] Open analysis window',
  props<{
    tab: 'chart' | 'table';
    metrics: Array<TimestreamMetric>;
    steps: number;
    period: number;
    simulation: SimulationType;
  }>()
);
